import { useCallback, useEffect } from 'react';
import { FAVORITE_QUICK_ENTITIES } from 'constants/entities';
import { RootState } from 'store';
import {
  setFavorites,
  toggleFavorite,
} from 'store/slices/userSettings/favoriteSlice';

import { useAppDispatch, useAppSelector } from './redux';

export const useFavoriteObjects = () => {
  const dispatch = useAppDispatch();

  const favorites = useAppSelector(
    (state: RootState) => state.settings.favoritesObjectTypes.favorites
  );

  const toggleFavoriteHandler = useCallback(
    (value: string, isFavorite: boolean) => {
      dispatch(toggleFavorite({ value, isFavorite }));

      const updatedFavorites = { ...favorites, [value]: isFavorite };

      localStorage.setItem(
        FAVORITE_QUICK_ENTITIES,
        JSON.stringify(updatedFavorites)
      );
    },
    [favorites]
  );

  useEffect(() => {
    const storedData = localStorage.getItem(FAVORITE_QUICK_ENTITIES);

    if (storedData) {
      dispatch(setFavorites(JSON.parse(storedData)));
    }
  }, [dispatch]);

  return { favorites, toggleFavorite: toggleFavoriteHandler };
};
